import React, { useState, useEffect } from "react";
import { api_url } from "../../constant/constant";
import { showToast } from "../../Components/ShowToast/ToastNotification";
import { useTranslation } from "react-i18next";
import {
  useNavigate,
  useLocation,
  useParams,
} from "react-router-dom";

const typeOptions = [
  "By Department",
  "By Campaign",
  "Who were Phished",
  "Failed Users",
];

const operatorOptions = [">", "<", "=", "<=", ">="];

const AttachbyuserComplianceuser = () => {
  const navigate = useNavigate();
  const [mode, setMode] = useState("");
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const LearningManager_id = searchParams.get("LearningManager_id");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const { id } = useParams();
  // const [thirdType, setThirdType] = useState("");
  const [phishingCampaigns, setPhishingCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [relation, setRelation] = useState("AND");
  const [filters, setFilters] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [phishedUsers, setPhishedUsers] = useState([]);
  const [selectedType, setSelectedType] = useState("");
const [selectedValue, setSelectedValue] = useState("");
const [thirdType, setThirdType] =
  useState("");

const [thirdValue, setThirdValue] =
  useState("");
const [selectedSecondaryValue, setSelectedSecondaryValue] = useState("");

const [selectedCampaignId, setSelectedCampaignId] = useState("");
  const handlePhishedCampaignChange = (campaignId, isSecondary = false) => {
  fetchPhishedUsers(campaignId);

  if (isSecondary) {
    setSelectedSecondaryValue("");
  } else {
    setSelectedValue("");
  }
};
  const [relation, setRelation] = useState("");
  const typeOptions = [
    "By Department",
    "By Campaign",
    "Who were Phished",
  ];
  
  const [selectedSecondaryType, setSelectedSecondaryType] = useState("");
  
  //  Fetch Phished Users
  const fetchPhishedUsers = async (campaignId) => {
    if (!campaignId) {
      setPhishedUsers([]);
      return;
    }

    try {
      const token = localStorage.getItem("userToken");

      const response = await fetch(
        `${api_url}/report/phishing/users-summary?campaign_id=${campaignId}&opened_per_page=5&clicked_per_page=15&submitted_per_page=5`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      if (result.status === "success") {
        setPhishedUsers(result.data?.users?.phished?.data || []);
      } else {
        setPhishedUsers([]);
      }
    } catch (error) {
      console.error("Error fetching phished users:", error);
      setPhishedUsers([]);
    }
  };

  //  Fetch Departments
  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const token = localStorage.getItem("userToken");

        const response = await fetch(
          `${api_url}/admin/main/departments`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch departments");
        }

        const result = await response.json();

        setDepartments(result.data || []);
      } catch (error) {
        console.error(error);
        showToast(t("fetcherror"), "error");
      }
    };

    fetchDepartment();
  }, [t]);

  //  Fetch Campaigns
  useEffect(() => {
    const fetchAllCampaigns = async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("userToken");

        let allCampaigns = [];
        let page = 1;
        let totalPages = 1;

        do {
          const response = await fetch(
            `${api_url}/learning-campaigns?page=${page}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const result = await response.json();

          const campaignData =
            result.learning_campaigns?.data || [];

          allCampaigns = [...allCampaigns, ...campaignData];

          totalPages =
            result.learning_campaigns?.last_page || 1;

          page++;
        } while (page <= totalPages);

        setCampaigns(allCampaigns);
      } catch (error) {
        console.error("Error fetching campaigns:", error);
        showToast(t("errorfetchingdata"), "error");
      } finally {
        setLoading(false);
      }
    };

    fetchAllCampaigns();
  }, [t]);

  //  Fetch Phishing Campaigns
  useEffect(() => {
    const fetchPhishingCampaigns = async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("userToken");

        const response = await fetch(
          `${api_url}/phishing-campaigns?page=1`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch phishing campaigns");
        }

        const result = await response.json();

        setPhishingCampaigns(result.data?.data || []);
      } catch (error) {
        console.error(
          "Error fetching phishing campaigns:",
          error
        );

        showToast(
          t("errorfetchingphishingcampaigndata"),
          "error"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchPhishingCampaigns();
  }, [t]);

  // 🔹 Add Filter
  const addFilter = () => {
    setFilters((prev) => [
      ...prev,
      {
        id: Date.now(),
        type: "",
        operator: "",
        value: "",
      },
    ]);
  };

  //  Remove Filter
  const removeFilter = (id) => {
    setFilters((prev) =>
      prev.filter((f) => f.id !== id)
    );
  };

  // 🔹 Handle Filter Change
  const handleFilterChange = async (
    id,
    name,
    value
  ) => {
    setFilters((prev) =>
      prev.map((f) => {
        if (f.id === id) {
          // Fetch phished users on phishing campaign select
          if (
            name === "value" &&
            f.type === "By Phishing"
          ) {
            fetchPhishedUsers(value);
          }

          // Auto select campaign
          if (
            name === "type" &&
            value === "By Campaign" &&
            !f.value
          ) {
            return {
              ...f,
              type: value,
              value: LearningManager_id || "",
            };
          }

          return {
            ...f,
            [name]: value,
          };
        }

        return f;
      })
    );
  };

  //  Available Types
  const availableTypes = (currentId) => {
    const selectedTypes = filters
      .filter((f) => f.id !== currentId)
      .map((f) => f.type);

    return typeOptions.filter(
      (type) => !selectedTypes.includes(type)
    );
  };

  //  Type Mapping
  const mapTypeToApi = (type) => {
    switch (type) {
      case "By Department":
        return "by_department";

      case "By Campaign":
        return "by_campaign";

      case "Who were Phished":
        return "who_were_phished";

      case "By Phishing":
        return "by_phishing";

      case "Failed Users":
        return "failed_users";

      default:
        return "";
    }
  };

  //  Available Campaigns
  const getAvailableCampaigns = (
    currentFilterValue
  ) => {
    const selectedCampaignIds = filters
      .filter(
        (f) =>
          f.type === "By Campaign" && f.value
      )
      .map((f) => Number(f.value));

    return campaigns.filter(
      (c) =>
        c.id === Number(currentFilterValue) ||
        (!selectedCampaignIds.includes(c.id) &&
          c.id !== Number(LearningManager_id))
    );
  };

  //  Payload
  const payload = {
    relation,
    filters: filters
      .filter((f) => f.type)
      .map((f) => ({
        type: mapTypeToApi(f.type),
        ...(f.operator
          ? { operator: f.operator }
          : {}),
        ...(f.value ? { value: f.value } : {}),
      })),
  };

  //  Submit
  const handleSubmit = async () => {
    if (!id) {
      showToast(
        t("InvalidComplianceManagerId"),
        "error"
      );
      return;
    }
  
    const simplePayload = {
      relation: relation || "AND",
      filters: filters
        .filter((f) => f.type && f.value !== "")
        .map((f) => ({
          type: mapTypeToApi(f.type),
          value: Number(f.value),
        })),
    };
  
    const complexPayload = {
      primary_filter: {
        type: mapTypeToApi(selectedType),
        value: Number(selectedValue),
      },
    
      secondary_relation: relation,
    
      secondary_filters: [
        {
          type: mapTypeToApi(selectedSecondaryType),
          value: Number(selectedSecondaryValue),
        },
    
        ...(thirdType && thirdValue
          ? [
              {
                type: mapTypeToApi(thirdType),
                value: Number(thirdValue),
              },
            ]
          : []),
      ],
    };
  
    const finalPayload =
      mode === "Complex"
        ? complexPayload
        : simplePayload;
  
    console.log("FINAL PAYLOAD", finalPayload);
  
    setLoading(true);
  
    try {
      const token = localStorage.getItem("userToken");

      const response = await fetch(
        `${api_url}/bulk-enrollment/compliance/${id}/enroll-users`,
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(finalPayload)
        
        }
      );

      const result = await response.json();

      console.log("Payload:", payload);
      console.log("API Response:", result);

      if (response.ok) {
        showToast(
          t("FilterAppliedSuccessfully"),
          "success"
        );

        navigate(-1);
      } else {
        showToast(
          result?.message?.en ||
            result?.message ||
            t("SomethingWentWrong"),
          "error"
        );
      }
    } catch (error) {
      console.error("Error:", error);

      showToast(t("NetworkError"), "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-4">
        {t("AddUsersUsingQuery")}
      </h3>
  
      {/* Mode Selection */}
      <div className="mb-3">
        <label className="form-label">
          Select Mode
        </label>
  
        <select
          className="form-select"
          value={mode}
          onChange={(e) => setMode(e.target.value)}
        >
          <option value="">Select Mode</option>
          <option value="Complex">Complex</option>
          <option value="Simple">Simple</option>
        </select>
      </div>
      {mode === "Complex" && (
  <div>

    {/* 1. TYPE SELECT */}
    {mode === "Complex" && (
  <div className="mb-3">
    <label className="form-label">(Primary) Select Type</label>

    <select
      className="form-select"
      value={selectedType}
      onChange={(e) => {
        setSelectedType(e.target.value);
        setSelectedSecondaryType("");
        setSelectedValue("");
        setRelation("");
        setThirdType("");
      }}
    >
      <option value="">Select Type</option>

      {typeOptions.map((type) => (
        <option key={type} value={type}>
          {type}
        </option>
      ))}
    </select>
  </div>
)}

    {/* 2. VALUE SELECT (DEPEND ON TYPE) */}
    {selectedType && (
  <div className="mb-3">
    <label>Primary Value</label>

    {selectedType === "By Department" && (
      <select
        className="form-select"
        value={selectedValue}
        onChange={(e) => setSelectedValue(e.target.value)}
      >
        <option value="">Select Department</option>
        {departments.map((d) => (
          <option key={d.id} value={d.id}>
            {d.name}
          </option>
        ))}
      </select>
    )}

    {selectedType === "By Campaign" && (
      <select
        className="form-select"
        value={selectedValue}
        onChange={(e) => setSelectedValue(e.target.value)}
      >
        <option value="">Select Campaign</option>
        {campaigns.map((c) => (
          <option key={c.id} value={c.id}>
            {c.title_en}
          </option>
        ))}
      </select>
    )}
{selectedType === "Who were Phished" && (
  <select
    className="form-select"
    value={selectedValue}
    onChange={(e) => {
      setSelectedValue(e.target.value);
      fetchPhishedUsers(e.target.value);
    }}
  >
    <option value="">Select Campaign</option>

    {phishingCampaigns.map((c) => (
      <option key={c.id} value={c.id}>
        {c.name_en || c.name_ar}
      </option>
    ))}
  </select>
)}
  </div>
)}
{selectedType && (
  <div className="mb-3">
    <label>Secondary Type</label>

    <select
      className="form-select"
      value={selectedSecondaryType}
      onChange={(e) => {
        setSelectedSecondaryType(e.target.value);
        setSelectedSecondaryValue(""); // reset
      }}
    >
      <option value="">Select Type</option>

      {typeOptions
        .filter((t) => t !== selectedType)
        .map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
    </select>
  </div>
)}
{selectedSecondaryType && (
  <div className="mb-3">
    <label>Secondary Value</label>

    {selectedSecondaryType === "By Department" && (
      <select
        className="form-select"
        value={selectedSecondaryValue}
        onChange={(e) => setSelectedSecondaryValue(e.target.value)}
      >
        <option value="">Select Department</option>
        {departments.map((d) => (
          <option key={d.id} value={d.id}>
            {d.name}
          </option>
        ))}
      </select>
    )}

    {selectedSecondaryType === "By Campaign" && (
      <select
        className="form-select"
        value={selectedSecondaryValue}
        onChange={(e) => setSelectedSecondaryValue(e.target.value)}
      >
        <option value="">Select Campaign</option>
        {campaigns.map((c) => (
          <option key={c.id} value={c.id}>
            {c.title_en}
          </option>
        ))}
      </select>
    )}
{selectedSecondaryType === "Who were Phished" && (
  <select
    className="form-select"
    value={selectedSecondaryValue}
    onChange={(e) => {
      setSelectedSecondaryValue(e.target.value);
      fetchPhishedUsers(e.target.value);
    }}
  >
    <option value="">Select Campaign</option>

    {phishingCampaigns.map((c) => (
      <option key={c.id} value={c.id}>
        {c.name_en || c.name_ar}
      </option>
    ))}
  </select>
)}
  </div>
)}
    {/* 3. RELATION */}
    {/* {selectedSecondaryType && selectedSecondaryValue && (
  <div className="mb-3">
    <label>Relation</label>

    <select
      className="form-select"
      value={relation}
      onChange={(e) => setRelation(e.target.value)}
    >
      <option value="AND">AND</option>
      <option value="OR">OR</option>
    </select>
  </div>
)} */}


    {/* 4. SUBMIT */}
{/* RELATION */}
{selectedType &&
  selectedValue &&
  selectedSecondaryType &&
  selectedSecondaryValue && (
    <div className="mb-3">
      <label className="form-label">
        Relation
      </label>

      <select
        className="form-select"
        value={relation}
        onChange={(e) =>
          setRelation(e.target.value)
        }
      >
        <option value="">Select Relation</option>
        <option value="AND">AND</option>
        <option value="OR">OR</option>
      </select>
    </div>
)}
{relation && (
  <div className="mb-3">
    <label className="form-label">
      Select Third Type
    </label>

    <select
      className="form-select"
      value={thirdType}
      onChange={(e) => {
        setThirdType(e.target.value);
        setThirdValue("");
      }}
    >
      <option value="">
        Select Third Type
      </option>

      {typeOptions
        .filter(
          (t) =>
            t !== selectedType &&
            t !== selectedSecondaryType
        )
        .map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
    </select>
  </div>
)}
{thirdType === "By Department" && (
  <div className="mb-3">
    <label className="form-label">
      Department
    </label>

    <select
      className="form-select"
      value={thirdValue}
      onChange={(e) =>
        setThirdValue(e.target.value)
      }
    >
      <option value="">
        Select Department
      </option>

      {departments.map((d) => (
        <option key={d.id} value={d.id}>
          {d.name}
        </option>
      ))}
    </select>
  </div>
)}
{thirdType === "By Campaign" && (
  <div className="mb-3">
    <label className="form-label">
      Campaign
    </label>

    <select
      className="form-select"
      value={thirdValue}
      onChange={(e) =>
        setThirdValue(e.target.value)
      }
    >
      <option value="">
        Select Campaign
      </option>

      {campaigns.map((c) => (
        <option key={c.id} value={c.id}>
          {c.title_en}
        </option>
      ))}
    </select>
  </div>
)}
{thirdType === "Who were Phished" && (
  <div className="mb-3">
    <label className="form-label">
      Phishing Campaign
    </label>

    <select
      className="form-select"
      value={thirdValue}
      onChange={(e) => {
        setThirdValue(e.target.value);
        fetchPhishedUsers(e.target.value);
      }}
    >
      <option value="">
        Select Campaign
      </option>

      {phishingCampaigns.map((c) => (
        <option key={c.id} value={c.id}>
          {c.name_en || c.name_ar}
        </option>
      ))}
    </select>
  </div>
)}
{selectedType &&
 selectedValue &&
 selectedSecondaryType &&
 selectedSecondaryValue &&
 relation &&
 thirdType &&
 thirdValue && (
   <button onClick={handleSubmit}>
     Submit
   </button>
)}
  </div>
)}

      {/* Simple Mode */}
     
      {mode === "Simple" && (
  <>
    {/* Relation */}
    <div className="mb-3">
      <label className="form-label">
        {t("Relation(AND/OR)")}
      </label>

      <select
        className="form-select"
        value={relation}
        onChange={(e) => setRelation(e.target.value)}
      >
        <option value="AND">{t("AND")}</option>
        <option value="OR">{t("OR")}</option>
      </select>
    </div>

    {/* Filters */}
    {filters.map((filter) => (
      <div key={filter.id} className="border p-3 mb-3 rounded">

        {/* TYPE */}
        <div className="mb-2">
          <label className="form-label">{t("Type")}</label>

          <select
            className="form-select"
            value={filter.type}
            onChange={(e) =>
              handleFilterChange(
                filter.id,
                "type",
                e.target.value
              )
            }
          >
            <option value="">{t("SelectType")}</option>

            {availableTypes(filter.id).map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {/* ============================= */}
        {/* WHO WERE PHISHED (API DATA) */}
        {/* ============================= */}
        {filter.type === "Who were Phished" && (
          <div className="mb-2">
            <label className="form-label">
              {t("PhishingCampaign")}
            </label>

            <select
              name="value"
              className="form-select"
              value={filter.value}
              onChange={(e) =>
                handleFilterChange(
                  filter.id,
                  "value",
                  e.target.value
                )
              }
            >
              <option value="">
                {t("SelectPhishingCampaign")}
              </option>

              {phishingCampaigns.length > 0 ? (
                phishingCampaigns.map((p) => (
                  <option key={p.id} value={p.id}>
                    {i18n.language === "ar"
                      ? p.name_ar
                      : p.name_en || `Phishing ${p.id}`}
                  </option>
                ))
              ) : (
                <option disabled>
                  {t("NoDataFound")}
                </option>
              )}
            </select>
          </div>
        )}

        {/* DEPARTMENT */}
        {filter.type === "By Department" && (
          <div className="mb-2">
            <label className="form-label">
              {t("Department")}
            </label>

            <select
              className="form-select"
              value={filter.value}
              onChange={(e) =>
                handleFilterChange(
                  filter.id,
                  "value",
                  e.target.value
                )
              }
            >
              <option value="">
                {t("SelectDepartment")}
              </option>

              {departments.map((d) => (
                <option key={d.id} value={d.id}>
                  {d.name}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* CAMPAIGN */}
        {filter.type === "By Campaign" && (
          <div className="mb-2">
            <label className="form-label">
              {t("Campaign")}
            </label>

            <select
              className="form-select"
              value={filter.value}
              onChange={(e) =>
                handleFilterChange(
                  filter.id,
                  "value",
                  e.target.value
                )
              }
            >
              <option value="">
                {t("SelectCampaign")}
              </option>

              {campaigns?.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.title_en || `Campaign ${c.id}`}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* REMOVE */}
        <button
          type="button"
          className="btn btn-danger btn-sm mt-2"
          onClick={() => removeFilter(filter.id)}
        >
          {t("Remove")}
        </button>
      </div>
    ))}

    {/* ADD FILTER */}
    <button
      type="button"
      className="btn btn-primary"
      onClick={addFilter}
    >
      {t("AddFilter")}
    </button>

    {/* SUBMIT */}
    <div className="mt-4 text-center">
      <button
        type="button"
        className="btn btn-success"
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? t("Loading...") : t("Submit")}
      </button>
    </div>
  </>
)}
    </div>
  );
};

export default AttachbyuserComplianceuser;